<template>
  <div>
    <b-row no-gutters  :style="gradientGobinet+'padding:10px;'" v-if="isTokenValidated()">
      <b-col >
        
        <!-- <b-navbar v-if="isTokenValidated()"  toggleable="lg"  sticky>
          <b-navbar-toggle target="nav-collapse" class="bg-toggle"></b-navbar-toggle>    
          <a class="navbar-brand" href="http://www.gobinet.mx" target="_blank"><img :src="icon" width="60"  class="d-none d-lg-block"></a>
          <b-navbar-brand class="m-auto d-block d-sm-block d-lg-none" href="#"><img :src="icon" width="60"></b-navbar-brand>
            
          
          
          <b-collapse id="nav-collapse" is-nav>
            <b-navbar-nav align="center">
              <b-nav-item v-if="catalogCobro != null"><router-link :to="municipio+'/cobro'"><font color="#ffffff"><b-icon icon="credit-card"/> Caja</font></router-link></b-nav-item>
              <b-nav-item v-if="catalogFormas != null"><router-link :to="municipio+'/formas'"><font color="#ffffff"><b-icon icon="files"/> Trámites</font></router-link></b-nav-item>
              <b-nav-item v-if="catalogReportes != null"><router-link :to="municipio+'/reportes'"><font color="#ffffff"><b-icon icon="graph-up"/> Reportes</font></router-link></b-nav-item>
              <b-nav-item v-if="catalogoPadrones != null"><router-link :to="municipio+'/padrones'"><font color="#ffffff"><b-icon icon="person-lines-fill"/> Padrones</font></router-link></b-nav-item>
              <b-nav-item ><router-link :to="municipio+'/config'"><font color="#ffffff" ><b-icon icon="tools"/> Configuración</font></router-link></b-nav-item>
            </b-navbar-nav>
          </b-collapse>
          
        </b-navbar> -->
        <b-button variant="light" @click="mostrarOcultarSideCobro()"><b-icon  icon="list"/></b-button>
      </b-col>
      
      <b-col>
        <img :src="icon" width="105"/>
      </b-col>
      
      <b-col cols="1">
        <b-row align="right">
          <b-col>
            <b-avatar  button @click="showPass=true"></b-avatar>
          </b-col>
        </b-row>
        
      </b-col>

      <!-- <b-col v-if="municipio.includes('aguacalimaya') || municipio =='calimaya'" cols="12" class="mt-2" align="right">
        <h4 style="color:red">Su versión de prueba terminó. Respalde su información
          </h4>
      </b-col>  -->
      
    </b-row>

    <b-row >
      
      <Transition>
        <b-col cols="12" sm="12" md="4" lg="3" xl="3" style="background-color:#f5f6f8;" v-if="isShowSideCobro">
          <SideBar/>
        </b-col>
      </Transition>

      <b-col cols="12" sm="12" :md="isShowSideCobro?8:12" :lg="isShowSideCobro?9:12" :xl="isShowSideCobro?9:12" style="background-color:#f5f6f8;">
        <b-row align-h="center">
          
          <!-- <b-col v-if="municipio.includes('acolman')" cols="12" class="mt-2" align="right"><h4 style="color:red">ESTE SOFTWARE ES UNA VERSIÓN DE PRUEBA v4.0.30 (Vigencia 31/10/2025)</h4></b-col> -->
          
          <b-col>
            <router-view style=" min-height: 2000px;"/><br v-if="isTokenValidated()">
          </b-col>
          <b-col cols="12" style="color:gray">135</b-col>
        </b-row>  
      </b-col>      
      
    </b-row>
    
    <b-modal title="Cambiar contraseña" hide-footer header-bg-variant="dark" header-text-variant="light" v-model="showPass">
      <b-row>
        <b-col>
          <h6>Ingrese su nueva contraseña</h6>
        </b-col>
        
      </b-row>
      <b-row>
        <b-col>
          <b-form-input placeholder="Ingrese entre 8 y 12 caracteres" v-model="pass1"></b-form-input>
        </b-col>
        
      </b-row>
      <b-row class="mt-2">
        <b-col>
          <b-form-input placeholder="Confirme la contraseña" v-model="pass2"></b-form-input>
        </b-col>
        
      </b-row>
      <b-row class="mt-1">
        <b-col>
          <b-button variant="success" @click="cambiarContraseña()">Guardar contraseña</b-button>
        </b-col>
        
      </b-row>

      <b-row class="mt-5" v-if="catalogReportes!=null && catalogReportes.permisoCambiarOficinas">
        <b-col cols="12"><h6>Asignación de oficinas</h6></b-col>
        <b-col cols="12"><b-form-select :options="catalogReportes.usuariosReportes" @change="oficina=''" v-model="usuarioOficina"></b-form-select></b-col>
        <b-col cols="12"><b-form-select :options="catalogReportes.oficinas" v-model="oficina"></b-form-select></b-col>
        <b-col class="mt-1"><b-button variant="info" @click="cambiarOficina()">Cambiar oficina</b-button></b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
 import axios from 'axios';
  import { server, getPostConfig, handledError} from '@/axios-tools';
import { isTokenValid } from '@/auth-tools';
import { mapState} from 'vuex';
import SideBar from './SideBar.vue';
export default {
  computed: {
    ...mapState({
      catalogoPadrones: state => state.padrones.catalogoPadrones,
      catalogoAdmin: state => state.admin.catalogoAdmin,
      catalogFormas: state => state.formas.catalogFormas,
      catalogCobro: state => state.cobro.catalogCobro,
      catalogReportes: state => state.reportes.catalogReportes,
      isShowSideCobro: state => state.cobro.isShowSideCobro,
    }),
    icon: function(){
      var mpio = this.$route.params.municipio;
      return mpio.includes('aguahuix')?'/media/sah.ico':mpio.includes('pruebas')?'/media/logingob.ico':'/media/gobinetw.ico';
    },
    gradientGobinet: function(){
      const gobinet = "background: linear-gradient(308deg, #3b4ee8, #4c46e8, #6839e8,  #872be8, #9f20e9, #b117e7);  background-size: 180% 180%;  animation: gradient-animation 5s ease infinite;";
      const huixquilucan = "background: linear-gradient(308deg, #19225c, #19225c, #192075,  #192075, #0b4e91, #0b4e91);  background-size: 180% 180%;  animation: gradient-animation 5s ease infinite;";
      const mpio = this.$route.params.municipio;
      return   mpio.includes('huixqui') || mpio.includes('prueba') ? huixquilucan : gobinet;

    },
    diasLicencia(){
        // Fecha objetivo: 31 de enero de 2026 (mes 0 = enero)
      const fechaObjetivo = new Date(2026, 0, 31);

      // Fecha actual (hoy) a medianoche
      const hoy = new Date();
      hoy.setHours(0, 0, 0, 0);

      // Diferencia en milisegundos
      const diffMs = fechaObjetivo.getTime() - hoy.getTime();

      // Convertir a días
      const diffDias = Math.ceil(diffMs / (1000 * 60 * 60 * 24));

      return diffDias;
    }
  },
  components:{
    SideBar
  },
  data(){
    return{
      municipio: "/"+location.pathname.split("/", 2).toString().replace(",", ""),
      pass1:'',
      pass2:'',
      showPass: false,
      usuarioOficina:'',
      oficina:''
    }
  },
  methods: {
    isTokenValidated (){
      var dateToken = this.$store.state.login.dateToken;
      var token = this.$store.state.login.token;
      return isTokenValid(token, dateToken);
    },
    mostrarOcultarSideCobro(){
        this.$store.commit("updateIsShowSideCobro", !this.isShowSideCobro);
    },
    cambiarContraseña(){
      if(this.pass1==this.pass2){
        const token = this.$store.state.login.token;
        axios(
          getPostConfig(server.cambiarpass, null, token, {pass:this.pass1})
        ).then(()=> {
          alert('La contraseña se actualizó');
        }).catch(err => {
          alert(err)
          handledError(err, server.cambiarpass, this.$router, this.$store)
        });
        this.pass1='';
        this.pass2='';

      }else{
        alert('La contraseñas no coinciden');
      }
    },
    cambiarOficina(){
      if(this.usuarioOficina!=''){
        const token = this.$store.state.login.token;
        axios(
          getPostConfig(server.cambiaroficina, null, token, {oficina:this.oficina, usuario:this.usuarioOficina})
        ).then(res => {
          alert(res.data);
        }).catch(err => {
          alert(err)
          handledError(err, server.cambiaroficina, this.$router, this.$store)
        });
      }
    }
  }
}
</script>

<style>
.bg-navbar {
        background-color: #e85fec;
        /* background-color: #033758; */
}
.bg-toggle{
        background-color: white;
}
.bg-title {
      background-color: #343a40;
      /*background-color: #0668A7;*/
      height: 38px;
      text-align: left;
      box-shadow: 5px 2px 15px 5px #A4A3A3;
}
.footer-sipremweb{
      background-color: #033758;
      color: white;
}
.card-form-primary{
  box-shadow: 0px 5px 35px 5px #cccaca;
  border-radius: 5px;
  border-left: solid 4px rgb(255, 136, 0);  
  background-color:white;
}
.card-form-blue{
  box-shadow: 0px 5px 35px 5px #cccaca;
  border-radius: 5px;
  border-left: solid 4px rgb(0, 174, 255);  
  background-color:white;
}
.card-form-purple{
  box-shadow: 0px 5px 35px 5px #cccaca;
  border-radius: 5px;
  border-left: solid 4px rgb(153, 102, 255);  
  background-color:white;
}
.v-enter-active{
  transition: all 0.3s ease-out;
}
.v-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.v-enter-from,
.v-leave-to {
  transform: translateX(-200px);
  opacity: 0;
}

.modal-fullscreen {
    max-width: 100%;
    margin: 0;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100vh;
    display: flex;
    position: fixed;
    z-index: 100000;
}

/*ESTILO HEADER APP se paso a propiedad computada
.gradient-background {
  background: linear-gradient(308deg, #3b4ee8, #4c46e8, #6839e8,  #872be8, #9f20e9, #b117e7);
  background-size: 180% 180%;
  animation: gradient-animation 5s ease infinite;
}*/

@keyframes gradient-animation {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

</style>